import { createReference, isResource } from '@medplum/core';
import { ResourceInput } from '@medplum/react';

export interface AccessPolicyInputProps {
  readonly name: string;
  readonly defaultValue?: any;
  readonly onChange: (value: any | undefined) => void;
}

export function AccessPolicyInput(props: AccessPolicyInputProps): JSX.Element {
  return (
    <ResourceInput
      resourceType="AccessPolicy"
      name="accessPolicy"
      defaultValue={props.defaultValue}
      placeholder="Access Policy"
      onChange={(newValue) => {
        if (isResource(newValue)) {
          props.onChange(createReference(newValue));
        } else {
          props.onChange(undefined);
        }
      }}
    />
  );
}
